import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { installStripeDevWidgetHider } from './lib/hideStripeDevWidget';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element');

// Esconde o widget de dev-tools do Stripe (modo teste) que persistia no canto.
installStripeDevWidgetHider();

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
